/* Read https://hello.atlassian.net/wiki/spaces/DQ/pages/786078865 on how to instrument well. */

// These are entities in ProForma. Reuse as much as possible.
// Think carefully when making a new ActionSubject about whether you can reuse an existing one.
export enum ActionSubject {
	// Objects
	FORM = 'form', // An actual form on an issue.
	FORM_FIELD = 'formField', // A field in a form.
	FORM_FIELD_CHOICES_DATA_CONNECTION = 'formFieldChoicesDataConnection', // A data connection's choices in a form.
	FORM_FIELD_CHOICES_JIRA_FIELD = 'formFieldChoicesJiraField', // A Jira field's choices in a form.
	FORM_SETTINGS_LANGUAGE = 'formSettingsLanguage', // Language dropdown of a form in form settings.
	FORM_SETTINGS_SUBMIT = 'formSettingsSubmit', // Lock and PDF of a form on submit toggle in form settings.
	FORM_SETTINGS_ISSUE_CREATE = 'formSettingsIssueCreate', // Submit and validate on create toggle in form settings.
	FORM_SETTINGS_ISSUE_FORMS_TYPES = 'formSettingsIssueFormsTypes', // Issue forms types dropdown in form settings, enabled through issue forms toggle.
	FORM_SETTINGS_RECOMMENDED_FORMS_TYPES = 'formSettingsRecommendedFormsTypes', // Recommended forms types dropdown in form settings, enabled through recommended forms toggle.
	FORM_SETTINGS_REQUEST_CREATE_TYPES = 'formSettingsRequestCreateTypes', // Request create types dropdown in form settings, enabled through request create toggle ("Attach to request types").
	QUESTION_ANSWER = 'questionAnswer', // Answer of a Question in a form.
	TEMPLATE_FORM = 'templateForm', // A form in a project created by form builder than can be then instantiated on an issue.
	EXAMPLE_TEMPLATE = 'exampleTemplate', // Predefined templates available in the form builder that can be inserted into a template form.
	BUTTON = 'button',
	DROPDOWN_ITEM = 'dropdownItem',
	SELECT_ITEM = 'selectItem',
	FILTER = 'filter',
	LIST = 'list',
	PANEL = 'panel',
	SECTION = 'section',
	TABLE = 'table',
	MODAL = 'modal',
	PROFORMA_API = 'proformaAPI',
	PROFORMA_UI = 'proformaUI',
	SECTION_MESSAGE = 'sectionMessage',
	ATTACHMENT = 'proformaAttachment',
	ATTACHMENT_UPLOAD = 'proformaAttachmentUpload',
	ATTACHMENT_VIEWER = 'proformaAttachmentViewer',
	ATTACHMENT_VIEWER_CARD = 'proformaAttachmentViewerCard',
	REQUEST_TYPE = 'requestType',
	DUPLICATE_REQUEST_TYPE_LINKED_FIELDS_WARNING_MODAL = 'duplicateRequestTypeLinkedFieldsWarningModal',
	TRANSLATIONS_EDITOR = 'translationsEditor',
	FORM_PERMISSIONS = 'proformaFormPermissions',

	// Processes
	ADF_NODE_INSERT = 'adfNodeInsert',
	FORM_VALIDATION = 'formValidation',
	FORM_EDIT = 'formEdit',
	FORM_SAVE = 'formSave',
	SEARCH_ASYNC_CHOICES = 'searchAsyncChoices',
	FETCH_FORM_ATTACHMENTS = 'fetchFormAttachments',
	UPLOAD_ISSUE_FORM_ATTACHMENTS = 'uploadFormAttachments',
	TRANSLATIONS_LANGUAGES_LOAD = 'translationsLoad',
	TRANSLATIONS_LOAD = 'translationsLoad',
	TRANSLATIONS_SAVE = 'translationsSave',
	TRANSLATIONS_DELETE = 'translationsDelete',
}

// Actions that can be performed on ActionSubjects. Try to use common ones from the list.
// See https://hello.atlassian.net/wiki/spaces/DQ/pages/1021070478
export enum Action {
	// Objects
	ADDED = 'added', // When an entity is added/inserted into another.
	CLICKED = 'clicked',
	CREATED = 'created',
	DELETED = 'deleted',
	DOWNLOADED = 'downloaded',
	EXPORTED = 'exported',
	UPDATED = 'updated',
	VIEWED = 'viewed',
	SELECTED = 'selected',
	COPIED = 'copied',

	// Processes
	FAILED = 'failed',
	FINISHED = 'finished',
	STARTED = 'started',
	STOPPED = 'stopped',
}

// Mechanisms to update a Form.
export enum FormUpdateType {
	REOPEN = 'REOPEN',
	SAVE = 'SAVE',
	SET_EXTERNAL = 'SET_EXTERNAL',
	SET_INTERNAL = 'SET_INTERNAL',
	SUBMIT = 'SUBMIT',
	CLOSE = 'CLOSE', // Similar to SUBMIT, used in "Close customer edits" option in form card meatball menu
}
